/**
 * @module announcement-banner
 *
 * Handles parsing announcements pulled from contentful and
 * displaying one in a site announcement banner.
 */

import { getWindow, selectOne, addClass, removeClass } from './utils/dom-utils';


function parseAnnouncements() {
  const announcements = getWindow().olarkSiteAnnouncements || {};
  const now = new Date();
  const currentAnnouncements = [];

  // Filter out announcements that are upcoming or have expired.
  Object.keys(announcements).forEach(key => {
    const item = announcements[key];
    item.announcementStartDate = new Date(item.announcementStartDate);
    item.announcementEndDate = new Date(item.announcementEndDate);

    if (item.announcementStartDate <= now && item.announcementEndDate > now) {
      currentAnnouncements.push(item);
    }
  });

  // Sort current announcements by start date so that we can
  // display only the most recent one if there are multiple
  // current announcements.
  currentAnnouncements.sort((a, b) => {
    if (a.announcementStartDate < b.announcementStartDate) {
      return -1;
    } else if (a.announcementStartDate > b.announcementStartDate) {
      return 1;
    } else {
      return 0;
    }
  });

  // Return the last (most recently started) announcement from the list.
  return currentAnnouncements[currentAnnouncements.length - 1];
}


function displayAnnouncement(announcement) {
  const banner  = selectOne('#js-announcement-banner');
  const link    = selectOne('#js-announcement-banner-link');
  const content = selectOne('#js-announcement-banner-content');
  const arrow   = selectOne('#js-announcement-banner-arrow');

  if (announcement.announcementLink) {
    link.setAttribute('href', announcement.announcementLink);
    addClass(link, 'live');
    removeClass(arrow, 'hidden');
  }

  content.innerHTML = announcement.announcementText;

  removeClass(banner, 'hidden');
}

/*
 * Assumes that partials/announcement.html creates a script tag
 * injecting a global variable called `olarkSiteAnnouncements`
 * containing JSON data from Contentful.
 * 
 * Filters out non-current announcements and selects the most
 * recent announcement for display.
 * 
 * Displays the selected announcement if we have one.
 */
export default function initAnnouncements() {
  getWindow().addEventListener('load', () => {
    const announcement = parseAnnouncements();
    if (announcement) {
      displayAnnouncement(announcement);
    }
  });
}